(() => {
    const collectionRoot = document.querySelector('.main-collection');
    if (!collectionRoot) return;

    /* ––– 0. Config ––– */
    const API_BASE = window.COLOR_APP_BASE ||
                     'https://color-swatches-app-production.up.railway.app';
    const collectionId = window.COLLECTION_ID;
    if (!collectionId) return;
  const LIMITED_STOCK_THRESHOLD = 75;
    const LIMITED_STOCK_DEFAULT_TEXT = "Limited Stock";
    const LIMITED_STOCK_VARIANT_TEXT = "Selling Fast";
    const LIMITED_STOCK_VARIANT_CLASS = "selling-fast-badge-test-a";
    const LIMITED_STOCK_LABEL_ATTRIBUTE = "data-limited-stock-badge-label";
    const isPlainObject = value =>
      value && typeof value === "object" && !Array.isArray(value);
  
    /* ––– 1. Detect market ––– */
    const detectMarket = () =>
      (window.Shopify?.country ||
       window.Shopify?.localization?.country?.iso_code ||
       document.documentElement.lang?.split('-').pop() || '')
        .toLowerCase() === 'us' ? 'us' : 'ca';
  
    /* ––– 2. Helpers (hide & mark swatches) ––– */
    const canon = str => (str||'').trim().replace(/^_+/, '').replace(/\s+/g,' ').toLowerCase();
    const getProductId = cardEl => {
      let pid = cardEl.dataset.productId || "";
      if (pid.includes("gid://")) pid = pid.split("/").pop();
      return pid.trim();
    };
    const getShadeExcludedProduct = () => {
      const params = new URLSearchParams(window.location.search);

      return {
        handle: (params.get("exclude-product-handle") || "").trim(),
        productId: (params.get("exclude-product-id") || "").trim(),
      };
    };
    const isShadeExcludedCard = cardEl => {
      if (cardEl.dataset.collectionShadeExcluded === "true") return true;

      const excludedProduct = getShadeExcludedProduct();
      if (!excludedProduct.handle && !excludedProduct.productId) return false;

      const cardHandle = (cardEl.dataset.productHandle || "").trim();
      const cardProductId = getProductId(cardEl);

      return (
        (excludedProduct.handle && cardHandle === excludedProduct.handle) ||
        (excludedProduct.productId && cardProductId === excludedProduct.productId)
      );
    };
    const isGeoHidingExemptCard = cardEl =>
      cardEl.dataset.geoHidingExempt === "true";
    const getExperimentTargets = () =>
      [
        document.documentElement,
        document.body,
        document.querySelector(".main-collection"),
      ].filter(Boolean);
    const getConfiguredLimitedStockLabel = () => {
      const runtimeLabel =
        typeof window.__limitedStockBadgeLabel === "string"
          ? window.__limitedStockBadgeLabel.trim()
          : "";
      if (runtimeLabel) return runtimeLabel;

      for (const target of getExperimentTargets()) {
        const attributeLabel = target.getAttribute?.(LIMITED_STOCK_LABEL_ATTRIBUTE)?.trim();
        if (attributeLabel) return attributeLabel;
      }

      const hasSellingFastVariant = getExperimentTargets().some(target =>
        target.classList?.contains(LIMITED_STOCK_VARIANT_CLASS)
      );

      return hasSellingFastVariant
        ? LIMITED_STOCK_VARIANT_TEXT
        : LIMITED_STOCK_DEFAULT_TEXT;
    };
    const syncAllLimitedStockBadgeLabels = () => {
      const activeLabel = getConfiguredLimitedStockLabel();

      document.querySelectorAll(".limited-stock-badge").forEach(badge => {
        badge.textContent = activeLabel;
      });
    };
    const setLimitedStockBadgeLabel = label => {
      if (typeof label === "string" && label.trim()) {
        window.__limitedStockBadgeLabel = label.trim();
      } else {
        delete window.__limitedStockBadgeLabel;
      }

      syncAllLimitedStockBadgeLabels();
    };
    const observeBadgeExperimentState = () => {
      const observer = new MutationObserver(syncAllLimitedStockBadgeLabels);

      getExperimentTargets().forEach(target => {
        observer.observe(target, {
          attributes: true,
          attributeFilter: ["class", "data-limited-stock-badge-label"],
        });
      });
    };
    window.UnboundExperiments = window.UnboundExperiments || {};
    window.UnboundExperiments.setLimitedStockBadgeLabel = setLimitedStockBadgeLabel;
    window.UnboundExperiments.resetLimitedStockBadgeLabel = () => {
      setLimitedStockBadgeLabel("");
    };
    window.addEventListener("unbound:limited-stock-badge-label-change", event => {
      setLimitedStockBadgeLabel(event.detail?.label || "");
    });
    observeBadgeExperimentState();
    syncAllLimitedStockBadgeLabels();
    const normalizeInventoryMap = rawData => {
      if (!rawData) return null;

      if (Array.isArray(rawData)) {
        return rawData.reduce((acc, item) => {
          const id = item?.product_id || item?.productId || item?.id;
          if (id != null) acc[String(id)] = item;
          return acc;
        }, {});
      }

      if (isPlainObject(rawData.products)) return rawData.products;
      if (isPlainObject(rawData.inventory)) return rawData.inventory;
      if (isPlainObject(rawData.data)) return rawData.data;
      if (isPlainObject(rawData)) return rawData;

      return null;
    };
    const getInventoryEntry = (inventoryMap, productId) =>
      inventoryMap?.[productId] ||
      inventoryMap?.[String(productId)] ||
      inventoryMap?.products?.[productId] ||
      inventoryMap?.inventory?.[productId] ||
      null;
    const getSoldOutColors = inv =>
      inv?.sold_out_colors ||
      inv?.soldOutColors ||
      inv?.inventory?.sold_out_colors ||
      inv?.inventory?.soldOutColors ||
      [];
    const getVariantQtyMap = inv =>
      inv?.variant_qty ||
      inv?.variantQty ||
      inv?.inventory?.variant_qty ||
      inv?.inventory?.variantQty ||
      null;
    const getVariantColorMap = inv =>
      inv?.variant_color ||
      inv?.variantColor ||
      inv?.inventory?.variant_color ||
      inv?.inventory?.variantColor ||
      null;
    const getPrimaryLimitedStockVariantIds = cardEl => {
      const raw = (cardEl.dataset.limitedStockPrimaryVariantIds || "").trim();
      if (!raw) return null;

      return new Set(
        raw
          .split(",")
          .map(id => id.trim())
          .filter(Boolean)
      );
    };
    const isBundleCard = cardEl => {
      const titleTxt = cardEl.querySelector(".product-card__title")?.textContent || "";
      return /\b(pack|packs|bundle|bundles)\b/i.test(titleTxt);
    };
    const getVisibleSwatches = cardEl =>
      Array.from(cardEl.querySelectorAll('.color-swatch[data-color]:not([data-hide]):not(.size-hidden)'));
    const getLimitedStockBadge = cardEl => {
      let badge = cardEl.querySelector(".limited-stock-badge");
      if (badge) return badge;

      const imageWrap = cardEl.querySelector(".product-card__image");
      if (!imageWrap) return null;

      badge = document.createElement("div");
      badge.className = "limited-stock-badge";
      badge.textContent = getConfiguredLimitedStockLabel();
      badge.style.display = "none";
      imageWrap.appendChild(badge);

      return badge;
    };
    const cardHasActiveSavingsBadge = cardEl => {
      const priceRoots = Array.from(
        cardEl.querySelectorAll(".product-card__price .price, .product-card__price--mobile .price")
      );

      if (
        priceRoots.some(
          priceRoot =>
            priceRoot.classList.contains("price--on-sale") &&
            priceRoot.querySelector(".price__badge-sale")
        )
      ) {
        return true;
      }

      return Boolean(
        cardEl.querySelector(".product-card__price .price__saving-label, .product-card__price--mobile .price__saving-label")
      );
    };
    const syncLimitedStockBadge = (cardEl, inv) => {
      const badge = cardEl.querySelector(".limited-stock-badge");
      const variantQtyMap = getVariantQtyMap(inv);
      const variantColorMap = getVariantColorMap(inv);
      const shouldHide =
        !inv ||
        cardHasActiveSavingsBadge(cardEl) ||
        isBundleCard(cardEl) ||
        cardEl.dataset.hideCard === "1";

      if (shouldHide) {
        if (badge) badge.style.display = "none";
        return;
      }

      if (!variantQtyMap) {
        if (badge) badge.style.display = "none";
        return;
      }

      let totalProductQty = 0;
      const primaryVariantIds = getPrimaryLimitedStockVariantIds(cardEl);

      for (const [variantId, qty] of Object.entries(variantQtyMap)) {
        const rawColor = String(variantColorMap?.[variantId] || "").trim();
        if (rawColor.startsWith("_")) continue;
        if (primaryVariantIds && !primaryVariantIds.has(String(variantId))) continue;

        const num = Number(qty);
        if (num > 0) totalProductQty += num;
      }

      const shouldShow =
        totalProductQty > 0 &&
        totalProductQty <= LIMITED_STOCK_THRESHOLD;
      cardEl.dataset.limitedStockTotal = String(totalProductQty);
      cardEl.dataset.limitedStockEligible = shouldShow ? "1" : "0";

      if (!shouldShow) {
        if (badge) badge.style.display = "none";
        return;
      }

      const nextBadge = getLimitedStockBadge(cardEl);
      if (nextBadge) nextBadge.style.display = "block";
    };
  
    const markCard = (cardEl, soldOut = []) => {
      if (isShadeExcludedCard(cardEl)) {
        cardEl.dataset.collectionShadeExcluded = "true";
        cardEl.dataset.hideCard = "1";
        cardEl.style.display = "none";
        return;
      }

      if (isGeoHidingExemptCard(cardEl)) {
        cardEl.style.display = "";
        delete cardEl.dataset.hideCard;
        return;
      }

      const soldOutSet = new Set(soldOut.map(canon));
      cardEl.querySelectorAll('.color-swatch[data-color]').forEach(sw => {
        if (soldOutSet.has(canon(sw.dataset.color))) {
          sw.style.display = 'none';
          sw.dataset.hide = '1';
          sw.classList.remove('active');
        } else {
          sw.style.display = '';
          delete sw.dataset.hide;
        }
      });
      if (!cardEl.querySelector('.color-swatch.active:not([data-hide])')) {
        const first = cardEl.querySelector('.color-swatch[data-color]:not([data-hide])');
        if (first) first.classList.add('active');
      }
      const hasVisible = cardEl.querySelector('.color-swatch[data-color]:not([data-hide])');
      const isBundle = isBundleCard(cardEl);
      if (!hasVisible && !isBundle) {
        cardEl.style.display = 'none';
        cardEl.dataset.hideCard = '1';
      } else {
        cardEl.style.display = '';
        delete cardEl.dataset.hideCard;
      }
    };
  
    const applyInventoryMap = data => {
      const inventoryMap = normalizeInventoryMap(data);
      if (!inventoryMap) {
        console.warn("Collection inventory payload is invalid", data);
        return;
      }

      // cache for later
      window.__collectionInventoryCache = inventoryMap;
  
      document
        .querySelectorAll('.product-card[data-product-id]')
        .forEach(card => {
          const productId = getProductId(card);
          const inv = getInventoryEntry(inventoryMap, productId);

          markCard(card, getSoldOutColors(inv));
          window.syncCollectionSizeFilteredCards?.(card);
          syncLimitedStockBadge(card, inv);
          if (isShadeExcludedCard(card)) return;

          // swap featured image if its color isn't in stock
          const variantEl = card.querySelector('.product-card__variant-color');
          const current = canon(variantEl?.textContent);
          const available = getVisibleSwatches(card);

          if (available.length && !available.some(sw => canon(sw.dataset.color) === current) && !card.classList.contains('preorder-collection')) {
            card.querySelectorAll('.color-swatch.active').forEach(sw => sw.classList.remove('active'));
            setTimeout(() => {
              available[0].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }, 0);
          }
        });

      window.refreshCollectionProductCountDisplay?.();
      window.refreshCollectionColorFacets?.();
  
      document.body.dataset.inventoryReady = '1';
    };

    document.addEventListener("unbound:product-card-price-change", event => {
      const card = event.detail?.card;
      if (!(card instanceof Element)) return;

      const inventoryMap = normalizeInventoryMap(window.__collectionInventoryCache);
      if (!inventoryMap) return;

      const productId = getProductId(card);
      const inv = getInventoryEntry(inventoryMap, productId);
      syncLimitedStockBadge(card, inv);
    });
  
    /* ––– 3. Fetch once + cache ––– */
    const market = detectMarket();
    const invUrl = `${API_BASE}/inventory/collection?collectionId=${collectionId}&market=${market}`;
    const fetchInventoryPayload = () =>
      fetch(invUrl)
        .then(res => {
          if (!res.ok) throw new Error(`Inventory API error: ${res.status}`);
          return res.json();
        });
    const ensureInventoryPayload = async () => {
      try {
        const primaryData = window.__invPromise
          ? await Promise.resolve(window.__invPromise)
          : await fetchInventoryPayload();

        if (normalizeInventoryMap(primaryData)) return primaryData;
      } catch (error) {
        console.warn("Primary collection inventory promise failed", error);
      }

      const fallbackData = await fetchInventoryPayload();
      window.__invPromise = fallbackData;
      return fallbackData;
    };
    ensureInventoryPayload()
      .then(data => {
        window.__collectionInventoryCache = data;
        applyInventoryMap(data);
      })
      .catch(console.error);

    /* ––– 4. One body-wide observer for all new cards ––– */
    new MutationObserver(muts => {
      if (!window.__collectionInventoryCache) return;
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches('.product-card') || n.querySelector('.product-card'))) {
            applyInventoryMap(window.__collectionInventoryCache);
            return;  // no need to keep looping once we’ve reapplied
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

  })();
